<template>
  <div>
    <h3>Technologies</h3>
    <p>
      <strong>What technologies do you have experience using?</strong><br />
    </p>
    <div id="" v-for="(
          technology, index
          ) in  sgaTechnologies" :key="index">
      <div>
        <el-row>
          <el-col>
            <p>
              <i v-if="index > 0" class="el-icon-remove"
                style="color: #dc3c3c; font-size: 20px; margin-right: .5rem;"></i> Please enter a search term
            </p>
            <el-select placeholder="Enter a search term..." v-model="technology.selection"
              :disabled="!!technology.custom">
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <button type="button" class="ts-btn ts-btn-small ts-btn-grey ts-btn-wicon ts-btn-full mt20 mb20"
              style="text-align: left !important">
              Can't find what you're looking for? Add another technology
            </button>
          </el-col>
        </el-row>
        <el-row v-if="!!technology.custom">
          <el-col :span="23">
            <input type="text" autocomplete="off" class="el-input__inner" placeholder="Enter Technology"
              v-model="technology.custom" />
          </el-col>
          <el-col :span="1">
            <div class="remove-icon-container">
              <i class="el-icon-circle-close"
                style="color: #dc3c3c; font-size: 20px; text-align: center; cursor: pointer;"></i>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <p>
              Years of Experience
            </p>
            <el-select placeholder="Years of experience" v-model="technology.yearsOfExperience">
            </el-select>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
  
<script>


export default {
  props: {
    sgaTechnologies: {
      type: Array,
      default: () => [],
    }
  },
};
</script>

<style lang="scss" scoped>
.remove-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  margin-left: 1rem;
}
</style>
  
